import React, { Component } from 'react';
import { withRouter } from 'react-router';
import { withLocalize } from 'react-localize-redux';
import { push } from 'react-router-redux';
import { connect } from 'react-redux';
import * as Yup from 'yup';
import { compose } from 'recompose';
import styled from 'styled-components';
import _, { has, isEmpty } from 'lodash';
import { withFormik, Field } from 'formik';
import { Container, Form, Icon } from 'semantic-ui-react';
import Loader from '../common/loader';
import Image from '../common/image';
import { HHAlert } from '../common/util';
import { ALERT_TYPE } from '../common/constant';
import { userLogout } from '../actions';
import { fetchEventLists, fetchMoreEventLists, resetEventLists } from '../actions/event';
import Navbar from '../nav';
import Footer from '../footer';
// import { Tab } from '../../uiStandard/event/tab';
import { Button } from '../../uiStandard/event/button';
import { ListPagination } from '../../uiStandard/event/pagination';
import { EventListTile } from './components/tile/listTile';
import { Input as CustomInput } from '../../uiStandard/event/input';
import { FormSubmitButton } from '../../uiStandard/event/formInput';
import { TempHeading, FormContainer, SearchButton, SearchWrapper, MobileSearchWrapper, MobileSearchButton } from './index.js';

const INITIAL_NUM_PER_PAGE = 36;
const NUM_PER_PAGE = 6;

const formikEnhancer = withFormik({
  validationSchema: ({ translate }) =>
    Yup.object().shape({
      email: Yup.string().email(translate('form.error.string.email')).required(translate('form.error.mixed.required'))
    }),
  mapPropsToValues: () => ({
    email: ''
  }),
  handleSubmit: (values, { setSubmitting }) => {
    setSubmitting(true);
    if (isEmpty(values.email)) {
      setSubmitting(false);
      HHAlert({ id: 'alert.error.fillInRequiredFields' }, ALERT_TYPE.ERROR);
      return;
    }
    HHAlert({ id: 'alert.success.uploadSuccess' }, ALERT_TYPE.SUCCESS);
    setSubmitting(false);
  }
});

const RegularInput = styled(CustomInput)`
  width: 100%;
  margin-bottom: 1em;

  @media (max-width: 768px) {
    width: auto;
  }
`;


class EventList extends Component {
  state = {
    currentPage: 1,
    totalPageCount: 6,
    isLoading: true,
    isOnEvents: true,
    searchLoading: false,
    searchText: '',
    resultOpen: false,
    results: [],
    loadCount: 1
  }

  componentDidMount() {
    const { location } = this.props;
    if (location && has(location, 'state') && !isEmpty(location.state)) {
      const { searchTextQuery } = location.state;
      // eslint-disable-next-line react/no-did-mount-set-state
      this.setState({
        searchText: searchTextQuery
      }, () => this.initialize());
    } else {
      // eslint-disable-next-line react/no-did-mount-set-state
      this.setState({
        searchText: ''
      }, () => this.initialize());
    }
  }

  initialize = () => {
    const { eventList, user } = this.props;
    const { token } = user;
    const userToken = token || '';
    if (isEmpty(eventList)) {
      this.props.fetchEventLists(this.state.loadCount, INITIAL_NUM_PER_PAGE, userToken).then(() => {
        this.checkQuery();
      });
    } else {
      this.checkQuery();
    }
  }


  checkQuery = () => {
    const { eventList } = this.props;
    const { searchText } = this.state;

    if (searchText === '') {
      this.setState((prev) => ({
        ...this.state,
        isLoading: false,
        totalPageCount: Math.ceil(eventList.length / NUM_PER_PAGE),
        loadCount: prev.loadCount + 1
      }));
      return;
    }

    this.setState((prev) => ({
      ...this.state,
      loadCount: prev.loadCount + 1
    }), this.filterOptions);
  }


  filterOptions = () => {
    const reName = this.state.searchText.length > 0 ? new RegExp(_.escapeRegExp(this.state.searchText), 'i') : false;
    let isMatch;
    if (reName) {
      isMatch = result => reName.test(result.name);
    }
    // search matched events from searchEvents arr
    const { searchEvents } = this.props.initialEvents;
    const filteredResultsBySearch = _.filter(searchEvents, isMatch);
    // search matched events from eventList arr
    const MatchFromList = _.filter(this.props.eventList, isMatch);
    // combine only unique event
    const filteredResults = _.uniqBy([...filteredResultsBySearch, ...MatchFromList], 'name');
    this.setState({
      searchLoading: false,
      results: filteredResults,
      totalPageCount: isEmpty(filteredResults) || filteredResults.length < 7 ? 1 : Math.ceil(filteredResults.length / NUM_PER_PAGE),
      isLoading: false
    });
  }

  backClickEvent = () => {
    const { currentPage } = this.state;
    if (currentPage < 2) {
      this.setState({
        ...this.state,
        currentPage: 1
      });
      return;
    }
    this.setState(prevState => ({
      ...this.state,
      currentPage: prevState.currentPage - 1
    }));
  }

  nextClickEvent = () => {
    this.setState(prevState => ({
      ...this.state,
      currentPage: prevState.currentPage + 1
    }));
  }

  loadMore = (e) => {
    e.preventDefault();
    const { user } = this.props;
    const { token } = user;
    const { loadCount, searchText } = this.state;
    this.setState(() => ({
      isLoading: true
    }), () => {
      this.props.fetchMoreEventLists(loadCount + 1, INITIAL_NUM_PER_PAGE, token).then(() => {
      // if load more with search keywords, filter events from fetched events
        if (searchText.length > 1) {
          this.filterOptions();
        } else {
          this.setState(prevState => ({
            ...this.state,
            currentPage: prevState.currentPage + 1,
            totalPageCount: Math.ceil(this.props.eventList.length / NUM_PER_PAGE),
            isLoading: false,
            loadCount: prevState.loadCount + 1
          }));
        }
      });
    });
  }

  render() {
    const {
      eventList, user, translate, activeLanguage, isSubmitting, handleSubmit
    } = this.props;
    const {
      currentPage, totalPageCount, isOnEvents, searchLoading, resultOpen, results, searchText, isLoading
    } = this.state;

    // get current events
    const indexOfLastEvent = currentPage * NUM_PER_PAGE;
    const indexOfFirstEvent = indexOfLastEvent - NUM_PER_PAGE;

    let currentEvents;
    if (searchText && searchText.length > 0) {
      if (isEmpty(results)) {
        currentEvents = [];
      } else {
        currentEvents = results.slice(indexOfFirstEvent, indexOfLastEvent);
      }
    } else {
      currentEvents = eventList.slice(indexOfFirstEvent, indexOfLastEvent);
    }

    // const toggleTab = () => {
    //   this.setState({ isOnEvents: !isOnEvents });
    // };

    const onSearchChange = (e, { name, value }) => {
      this.setState({
        ...this.state,
        searchLoading: true,
        currentPage: 1,
        [name === 'name' ? 'searchText' : name]: value
      }, () => {
        if (this.state.searchText.length === 0) {
          this.setState({
            ...this.state,
            searchLoading: false
          });
        }
      });
    };

    const search = (e) => {
      e.preventDefault();
      this.filterOptions();
    };

    const toggleFocus = ({ type }) => {
      if (type === 'focus') {
        this.setState({ resultOpen: true });
      } else {
        this.setState({ resultOpen: false });
      }
    };

    const backToPreviousPage = () => {
      this.props.history.goBack();
    };

    if (isLoading) {
      return (
        <Loader />
      );
    }

    return (
      <PageWrapper>
        <ContentWrapper>
          <HeroWrapper>
            <Navbar />
            <BackButton onClick={backToPreviousPage}>
              <WhiteLeftArrow />{translate('back')}
            </BackButton>
          </HeroWrapper>
          <FormContainer onSubmit={search} isFocusing={resultOpen}>
            <SearchWrapper
              fluid
              loading={searchLoading}
              onFocus={toggleFocus}
              onBlur={toggleFocus}
              onSearchChange={onSearchChange}
              placeholder={translate('form.placeholder.searchHackathonsByName')}
              icon='search'
              value={searchText}
              open={false}
              name='name'
            />
            <SearchButton isPrimary isSmall label={translate('search')} />
            <MobileSearchWrapper
              fluid
              loading={searchLoading}
              onFocus={toggleFocus}
              onBlur={toggleFocus}
              onSearchChange={onSearchChange}
              placeholder={translate('form.placeholder.searchHackathons')}
              icon='search'
              value={searchText}
              open={false}
              name='name'
            />
            <MobileSearchButton
              isPrimary isSmall
              label={<Icon name='search' size='large' />}
            />
          </FormContainer>
          <ContainerWrapper>
            <ListContainer>
              {/* <Tab
                items={[translate('headTitle.events'), translate('headTitle.groups')]}
                focused={isOnEvents ? translate('headTitle.events') : translate('headTitle.groups')}
                clickEvent={toggleTab}
              /> */}
              <TempHeading>{translate('headTitle.events')}</TempHeading>
              {
                isOnEvents && !isEmpty(currentEvents) && (
                  currentEvents.map(event => (
                    <EventListTile
                      key={event.slug}
                      event={event}
                      activeLanguage={activeLanguage}
                    />
                  ))
                )
              }
              {
                isOnEvents && isEmpty(currentEvents) && (
                  <div>No events</div>
                )
              }
              {/* {
                  !isOnEvents && (
                    <Fragment>
                      <GroupListTile />
                      <GroupListTile />
                      <GroupListTile />
                      <GroupListTile />
                    </Fragment>
                  )
              } */}
              <PagiWrapper>
                {
                  currentPage === totalPageCount && user.isLoggedIn && (
                    <div>
                      <Button
                        label={translate('button.loadMore')}
                        onClick={this.loadMore}
                      />
                    </div>
                  )
                }
                <ListPagination
                  currentPage={currentPage}
                  totalPageCount={totalPageCount}
                  backClickEvent={this.backClickEvent}
                  nextClickEvent={this.nextClickEvent}
                  ch={false}
                />
              </PagiWrapper>
            </ListContainer>
            <NewsLetterContainer>
              <NewsLetter>
                <Image src='/img/general/subscription.png' />
                <NewsLetterHead className='head'>{translate('weeklyNewsLetter')}</NewsLetterHead>
                <NewsLetterMessage className='message'>{translate('newsLetterMessage')}</NewsLetterMessage>
                <Form onSubmit={handleSubmit}>
                  <Form.Field>
                    <Field
                      name='email'
                      component={RegularInput}
                      otherProps={{
                      id: 'email',
                          placeholder: translate('form.placeholder.emailAddress'),
                          type: 'email'
                        }}
                    />
                  </Form.Field>
                  <FormSubmitButton
                    loading={isSubmitting}
                    disabled={isSubmitting}
                    label={translate('button.subscribe')}
                  />
                </Form>
              </NewsLetter>
            </NewsLetterContainer>
          </ContainerWrapper>
        </ContentWrapper>
        <Footer />
      </PageWrapper>
    );
  }
}

const PageWrapper = styled.div`
  position: relative;
  width: 100%;
  min-height: 100vh;
`;

const ContentWrapper = styled.div`
  padding-bottom: 488px;
  width: 100%;
    @media only screen and (max-width: 992px) {
        padding-bottom: 700px;
    }

    @media only screen and (max-width: 768px) {
        padding-bottom: 900px;
    }
`;

const HeroWrapper = styled.div`
  width: 100%;
  height: 216px;
  background-image: url('/img/event/eventlist-section-bg.png');
  display: flex;
  justify-content:center;
  align-items:center;
  position: relative;
  background-size:cover;
`;

const PagiWrapper = styled.div`
  text-align:right;
  @media only screen and (max-width: 768px) { 
    text-align:center;
  }
`;

const ContainerWrapper = styled(Container)`
  margin-bottom: 3em;
  padding: 0 2em 2em 0;
  height: auto;
  &&.ui.container {
    display: flex;
    justify-content: space-between;
  }
  @media only screen and (max-width: 991px) { 
    padding: 0;
  }
  @media only screen and (max-width: 768px) { 
    &&.ui.container {
    flex-direction: column;
    }
  }

  @media only screen and (max-width: 375px) { 
    padding: 1em 0;
  }
`;

const ListContainer = styled.div`
  width: 60%;
  @media only screen and (max-width: 768px) { 
    width: 90%;
    margin: 1em auto;
  }

  @media only screen and (max-width: 375px) { 
    width:100%;
  }
`;

const BackButton = styled.button`
  position: absolute;
  bottom: 3em;
  left: 6em;
  font-family: 'Inter';
  font-style: normal;
  font-weight: 600;
  line-height: 19px;
  color: #FFFFFF;

  height: 20px;
  width: 70px;
  font-size: 17px;
  border: none;
  background-color: transparent;

  @media (max-width: 768px) {
    display: none;
  }
`;

const WhiteLeftArrow = styled.div`
  background-image: url('/img/icons/white-left-angle.png');
  background-repeat: no-repeat;
  background-size: 100%;
  height: 13px;
  width: 8px;
  display: inline-block;
  margin-right: 10px;
`;

const NewsLetterContainer = styled.div`
  width: 30%;
    @media only screen and (max-width: 1199px) { 
      width: 38%;
    }
    @media only screen and (max-width: 993px) { 
      width: 38%;
      margin: 0 auto;
    }
    @media only screen and (max-width: 768px) { 
      margin: 1em auto;
      width: 90%;
    }
`;

const NewsLetter = styled.div`
  width: 100%;
  height: 409px;
  background: #E6F5FF;
  border-radius: 18px;
  display: flex;
  flex-direction: column;
  justify-content:space-evenly;
  align-items: flex-start;
  padding: 2em;

  button {
    width: 100%;
  }

  @media only screen and (max-width: 768px) { 
    width: 70%;
    margin: 1em auto;
    height: auto;
    .form.ui.form {
      margin: 1em auto;
    }
  }
  @media only screen and (max-width: 600px) { 
    width: 100%;
  }

  .form.ui.form {
    width: 100%;
  }
`;

const NewsLetterHead = styled.span`
  font-family: 'Inter';
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 24px;
  color: #333333;
  @media only screen and (max-width: 768px) { 
    padding: 1em 0;
  }
`;

const NewsLetterMessage = styled.span`
  font-family: 'Quicksand';
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
  color: #676767;  
`;

export default compose(
  withLocalize,
  withRouter,
  formikEnhancer,
  connect(({ user, initialEvents, eventList }) => ({ user, initialEvents, eventList }),
    {
      push, userLogout, fetchEventLists, fetchMoreEventLists, resetEventLists
    })
)(EventList);



// WEBPACK FOOTER //
// ./src/components/events/list.js